import React from 'react';

function Footer() {
	return <body className='footerStyle'></body>;
}

export default Footer;
